import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import AskAIChat from './AskAIChat';

const AskAI = () => {
  const { user } = useAuth();
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="container-custom py-8 max-w-3xl">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Ask AI</h1>
        <p className="text-gray-600 mb-6">
          Ask about stocks, ETFs, technical &amp; fundamental analysis, or how to use GandalStock.
          Educational information only — not personalized financial advice.
          {!user && ' Sign in for a higher daily limit.'}
        </p>
        <div className="bg-white rounded-lg shadow border border-gray-200">
          <AskAIChat fullPage active />
        </div>
      </div>
    </div>
  );
};

export default AskAI;
